import { Logger } from "./logger";

/**
 * localStorage アクセス用のラッパー
 */
export module lstorage {

	/**
	 * 格納キー：編集情報
	 */
	export const KEY_EDIT: string = "ffposca_editInfo";
	/**
	 * 格納キー：注文情報
	 */
	export const KEY_ORDER: string = "ffposca_orderInfo";
	/**
	 * 格納キー：マスタ情報
	 */
	export const KEY_MASTER: string = "ffposca_masterInfo";
	/**
	 * 格納キー：GETパラメータ
	 */
	export const KEY_GETPARAM: string = "ffposca_getInfo";
	/**
	 * 格納キー：業務ロジック関連情報
	 */
	export const KEY_BUSINESS: string = "ffposca_businessInfo";


	/**
	 * localStorage へ書き込み
	 * @param key：キー
	 * @param val：設定値
	 */
	export function set<T>(key: string, val: T): boolean {

		try {
			const valTmp: string = JSON.stringify(val);
			window.localStorage.setItem(key, valTmp);

			return true;

		} catch (e) {
			Logger.error("localstorage set errr", e);
			return false;
		}
	}


	/**
	 * localStorage へ書き込み
	 * @param key		：キー
	 * @param allowNull	：取得結果のnull許容(true：nullを返却、false：exceptionを返却)
	 */
    export function get<T>(key: string, allowNull = false): T {

		try {
			const getVal: string = window.localStorage.getItem(key);

			if (getVal) {
				const returnVal: T = <T>JSON.parse(getVal);
				return returnVal;
			}
			else {
				if (allowNull) {
					return null;
				}
				else {
					throw new Error("localstorage get errr. not exists key-val key[" + key + "]");
                }
            }

		} catch (e) {
			Logger.error("localstorage get errr", e);
			throw new e;
		}
    }

	/**
	 * localStorage からの削除
	 * @param key		：キー
	 */
    export function del(key: string) {

		try {
			window.localStorage.removeItem(key);

		} catch (e) {
			Logger.error("localstorage del errr", e);
        }

	}



}